import React from 'react';

interface EmailExportCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

/**
 * Checkbox component for "as email" export option.
 * Matches the styling of the SelectionCheckbox used in BulkWinePage.
 */
export const EmailExportCheckbox: React.FC<EmailExportCheckboxProps> = ({
  checked,
  onChange,
  disabled = false,
}) => {
  return (
    <label className="inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        aria-label="Send as email"
        className="h-4 w-4 cursor-pointer appearance-none border border-[#7CB376] bg-white bg-center bg-no-repeat disabled:opacity-50 disabled:cursor-not-allowed"
        style={{
          backgroundColor: checked ? '#7CB376' : '#FFFFFF',
          borderColor: '#7CB376',
          backgroundImage: checked
            ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='8' viewBox='0 0 10 8' fill='none'%3E%3Cpath d='M1 4L3.5 6.5L9 1' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`
            : 'none',
          backgroundSize: '10px 8px',
          // Defensive sizing to prevent browser extension CSS conflicts
          width: '16px',
          minWidth: '16px',
          maxWidth: '16px',
          height: '16px',
          minHeight: '16px',
          maxHeight: '16px',
          boxSizing: 'border-box',
          flexShrink: 0,
        }}
      />
      <span
        className="ml-2 text-sm text-neutral-800"
        style={{
          fontFamily: 'Oxygen',
          fontSize: '14px',
          fontWeight: 400,
        }}
      >
        as email
      </span>
    </label>
  );
};

export default EmailExportCheckbox;
